export default __webpack_public_path__ + "static/media/logo1.39af2c8d.png";